import { environment } from "../../../Environments/environment";
import { PostAsyncHelper } from "../../../redux/interfaces/types";


export const GetExpediaPaymentOptions = async (priceCheckUri) => {


  let api_url = `${environment.apiUrl}muv-meta-engine/expedia/payment/getPaymentOptions?priceCheckUri=${priceCheckUri}`;
  const response = await PostAsyncHelper(api_url, {});
  const results = response?.data?.result;
  return results || null;
};
export const GetExpediaBooking = async (email, affiliate_reference_id) => {


  let api_url = `${environment.apiUrl}muv-meta-engine/expedia/getBookingDetails?affiliate_reference_id=${affiliate_reference_id}&email=${email}`;
  const response = await PostAsyncHelper(api_url, {});
  const results = response?.data;
  return results || null;
};

// export const CancelExpediaBooking = async (deleteReservationUrl) => {

//   let api_url = `${environment.apiUrl}muv-meta-engine/expedia/cancelBooking?deleteReservationUrl=${deleteReservationUrl}`;
//   const response = await PostAsyncHelper(api_url, {});
//   const results = response?.data;
//   return results || null;
// };


export const CancelExpediaBooking = async (email, affiliate_reference_id) => {


  let api_url = `${environment.apiUrl}muv-meta-engine/expedia/cancelBooking?affiliate_reference_id=${affiliate_reference_id}&email=${email}`;
  const response = await PostAsyncHelper(api_url, {});
  const results = response?.data;
  return results || null;
};
